<template>
    <div>
        <div>
            <div class="main-wrapper">
                <div>
                    <!-- <layout-header2></layout-header2> -->
                    <layout-header></layout-header>
                    <template>
                        <!-- Breadcrumb -->
                        <div class="breadcrumb-bar" style="background-color: #3CB371;">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-md-12 col-12">
                                        <nav aria-label="breadcrumb" class="page-breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                                                <li class="breadcrumb-item active" aria-current="page">Add Hospital</li>
                                            </ol>
                                        </nav>
                                        <h2 class="breadcrumb-title">Add Hospital</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /Breadcrumb -->
                    </template>
                    <!-- Page Content -->
                    <div class="content">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                    <sidebar></sidebar>
                                </div>
                                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                                    <loader></loader>
                                </div>
                                <div class="col-md-7 col-lg-8 col-xl-9" v-else>

                                    <div class="card ml-md-4">
                                        <div class="card-body">
                                            <div style="float: right;">
                                                <i class="fa fa-times" aria-hidden="true" @click="goBack"></i>
                                            </div>
                                            <div>
                                                <div class="card-body">
                                                    <ul class="nav nav-tabs">
                                                        <li class="nav-item">
                                                            <a class="nav-link active" data-toggle="tab"
                                                                href="#hospital-tab" style="color: #034320;">Hospital
                                                            </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a class="nav-link" data-toggle="tab" href="#gallery-tab"
                                                                style="color: #2fa4b9;">Hospital
                                                                Gallery</a>
                                                        </li>
                                                    </ul>
                                                    <div class="tab-content">
                                                        <!-- Profile Settings Form -->
                                                        <!-- <form @submit.prevent="add_dependent"> -->
                                                        <div class="tab-pane active" id="hospital-tab" role="tabpanel">
                                                            <div class="row form-row">
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Type of Hospital</label>
                                                                        <v-select class="mr-2" name="sub_category_name"
                                                                            required="" label="sub_category_name"
                                                                            placeholder="Select type of Hospital"
                                                                            v-model="new_hospital.type_of_hospital"
                                                                            :reduce="(option) => option.sub_category_name"
                                                                            :options="hospital_types">
                                                                        </v-select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Name of Hospital
                                                                            <span class="text-danger">*</span></label>
                                                                        <input v-model="new_hospital.name_of_hospital"
                                                                            type="text" class="form-control" value=""
                                                                            oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>No Of Beds</label>
                                                                        <input v-model="new_hospital.no_of_beds" type="text"
                                                                            class="form-control" value=""
                                                                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Website</label>
                                                                        <input v-model="new_hospital.website" type="text"
                                                                            class="form-control" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Tagline</label>
                                                                        <input v-model="new_hospital.hospital_tagline"
                                                                            type="text" class="form-control" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Address</label>
                                                                        <input v-model="new_hospital.address" type="text"
                                                                            class="form-control" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>State</label>
                                                                        <v-select class="mr-2" name="state" required=""
                                                                            label="state" placeholder="Select State"
                                                                            v-model="new_hospital.state"
                                                                            :reduce="(option) => option.state"
                                                                            @input="get_cities_for_addinghospital()"
                                                                            :options="states">
                                                                        </v-select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>City <span
                                                                                class="text-danger">*</span></label>
                                                                        <v-select class="mr-2" name="city" required=""
                                                                            label="city" placeholder="Select City"
                                                                            v-model="new_hospital.city"
                                                                            :reduce="(option) => option.city"
                                                                            :options="cities">
                                                                        </v-select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Suburb</label>
                                                                        <input v-model="new_hospital.suburb" type="text"
                                                                            class="form-control" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-md-6">
                                                                    <div class="form-group">
                                                                        <label>Pincode</label>
                                                                        <input v-model="new_hospital.pincode" type="text"
                                                                            class="form-control" value=""
                                                                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="tab-pane" id="gallery-tab" role="tabpanel">
                                                            <div class="container">
                                                                <div class="row">
                                                                    <div class="col-12 col-md-6 mb-2">
                                                                        <div class="change-avatar">
                                                                            <div class="profile-img m-2">
                                                                                <img v-bind:src="new_hospital.photo_1
                                                                                    ? config.base_url_for_Image + new_hospital.photo_1
                                                                                    : loadImg('doctor-thumb-02.jpg')"
                                                                                    alt="User Image" />
                                                                            </div>
                                                                            <div class="upload-img">
                                                                                <div class="change-photo-btn">
                                                                                    <span><i class="fa fa-upload"></i>
                                                                                        Upload</span>
                                                                                    <input type="file" class="upload"
                                                                                        accept="image/*"
                                                                                        @change="onFileChange($event, 'hospital_photo_1')" />
                                                                                </div>
                                                                                <small class="form-text text-muted">Allowed
                                                                                    JPG, GIF, or PNG. Max size of
                                                                                    2MB</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-12 col-md-6 mb-4">
                                                                        <div class="change-avatar">
                                                                            <div class="profile-img">
                                                                                <img v-bind:src="new_hospital.photo_2
                                                                                    ? config.base_url_for_Image + new_hospital.photo_2
                                                                                    : loadImg('doctor-thumb-02.jpg')"
                                                                                    alt="User Image" />
                                                                            </div>
                                                                            <div class="upload-img">
                                                                                <div class="change-photo-btn">
                                                                                    <span><i class="fa fa-upload"></i>
                                                                                        Upload</span>
                                                                                    <input type="file" class="upload"
                                                                                        accept="image/*"
                                                                                        @change="onFileChange($event, 'hospital_photo_2')" />
                                                                                </div>
                                                                                <small class="form-text text-muted">Allowed
                                                                                    JPG, GIF, or PNG. Max size of
                                                                                    2MB</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-12 col-md-6 mb-4">
                                                                        <div class="change-avatar">
                                                                            <div class="profile-img">
                                                                                <img v-bind:src="new_hospital.photo_3
                                                                                    ? config.base_url_for_Image + new_hospital.photo_3
                                                                                    : loadImg('doctor-thumb-02.jpg')"
                                                                                    alt="User Image" />
                                                                            </div>
                                                                            <div class="upload-img">
                                                                                <div class="change-photo-btn">
                                                                                    <span><i class="fa fa-upload"></i>
                                                                                        Upload</span>
                                                                                    <input type="file" class="upload"
                                                                                        accept="image/*"
                                                                                        @change="onFileChange($event, 'hospital_photo_3')" />
                                                                                </div>
                                                                                <small class="form-text text-muted">Allowed
                                                                                    JPG, GIF, or PNG. Max size of
                                                                                    2MB</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-12 col-md-6 mb-4">
                                                                        <div class="change-avatar">
                                                                            <div class="profile-img">
                                                                                <img v-bind:src="new_hospital.photo_4
                                                                                    ? config.base_url_for_Image + new_hospital.photo_4
                                                                                    : loadImg('doctor-thumb-02.jpg')"
                                                                                    alt="User Image" />
                                                                            </div>
                                                                            <div class="upload-img">
                                                                                <div class="change-photo-btn">
                                                                                    <span><i class="fa fa-upload"></i>
                                                                                        Upload</span>
                                                                                    <input type="file" class="upload"
                                                                                        accept="image/*"
                                                                                        @change="onFileChange($event, 'hospital_photo_4')" />
                                                                                </div>
                                                                                <small class="form-text text-muted">Allowed
                                                                                    JPG, GIF, or PNG. Max size of
                                                                                    2MB</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="submit-section text-left">
                                                    <button @click="add_hospital()" :disabled="disabled"
                                                        class="btn btn-primary submit-btn ml-4" data-dismiss="modal"
                                                        aria-label="Close">
                                                        Add Hospital
                                                    </button>
                                                </div>
                                                <!-- </form> -->
                                                <!-- /Profile Settings Form -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Content -->
                    <layout-footer></layout-footer>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import CommonApi from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
    data() {
        return {
            states: [],
            cities: [],
            hospital_types: [],
            new_hospital: {
                type_of_hospital: "",
                name_of_hospital: "",
                no_of_beds: "",
                website: "",
                hospital_tagline: "",
                address: "",
                state: "",
                city: "",
                suburb: "",
                pincode: "",
                photo_1: "",
                photo_2: "",
                photo_3: "",
                photo_4: "",
            },
        };
    },
    watch: {
        new_hospital: {
            handler() {
                this.validateForm();
            },
            deep: true,
        },
    },
    computed: {
        ...mapState({
            user_id: (state) => state.user.user_id,
        }),
    },
    methods: {
        goBack() {
            // Go one page back
            this.$router.go(-1);
        },
        /* Get Profile Image */
        loadImg(imgPath) {
            return images("./" + imgPath);
        },

        /* Create Profile Image */
        createImage(file, photo) {
            var reader = new FileReader();
            reader.onload = (e) => {
                if (photo === "main_image") {
                    this.update_doctor_profile(file.name, e.target.result);
                } else if (photo === "doctor_photo_1") {
                    this.doctor_gallery_photo_1_upload(file.name, e.target.result);
                } else if (photo === "doctor_photo_2") {
                    this.doctor_gallery_photo_2_upload(file.name, e.target.result);
                } else if (photo === "doctor_photo_3") {
                    this.doctor_gallery_photo_3_upload(file.name, e.target.result);
                } else if (photo === "doctor_photo_4") {
                    this.doctor_gallery_photo_4_upload(file.name, e.target.result);
                } else if (photo === "hospital_photo_1") {
                    this.hospital_gallery_photo_1_upload(file.name, e.target.result);
                } else if (photo === "hospital_photo_2") {
                    this.hospital_gallery_photo_2_upload(file.name, e.target.result);
                } else if (photo === "hospital_photo_3") {
                    this.hospital_gallery_photo_3_upload(file.name, e.target.result);
                } else if (photo === "hospital_photo_4") {
                    this.hospital_gallery_photo_4_upload(file.name, e.target.result);
                }
            };
            reader.readAsDataURL(file);
        },

        /* Change Profile Image */
        onFileChange(e, photo) {
            var files = e.target.files;
            if (!files.length) return;
            this.createImage(files[0], photo);
        },

        /* Upload HospitaL Gallary Image 1 API */
        async hospital_gallery_photo_1_upload(filename, upload_image) {
            let data = {
                filename: filename,
                decode_base64: 1,
                filedata: upload_image,
            };
            await CommonApi.post_data(
                "sahaj.document.hospital_gallery_photo_1_upload",
                JSON.stringify(data)
            ).then((res) => {
                if (res && res.status_code == 200) {
                    this.new_hospital.photo_1 = res.data.file_url;
                }
            });
        },

        /* Upload HospitaL Gallary Image 2 API */
        async hospital_gallery_photo_2_upload(filename, upload_image) {
            let data = {
                filename: filename,
                decode_base64: 1,
                filedata: upload_image,
            };
            await CommonApi.post_data(
                "sahaj.document.hospital_gallery_photo_2_upload",
                JSON.stringify(data)
            ).then((res) => {
                if (res && res.status_code == 200) {
                    this.new_hospital.photo_2 = res.data.file_url;
                }
            });
        },

        /* Upload HospitaL Gallary Image 3 API */
        async hospital_gallery_photo_3_upload(filename, upload_image) {
            let data = {
                filename: filename,
                decode_base64: 1,
                filedata: upload_image,
            };
            await CommonApi.post_data(
                "sahaj.document.hospital_gallery_photo_3_upload",
                JSON.stringify(data)
            ).then((res) => {
                if (res && res.status_code == 200) {
                    this.new_hospital.photo_3 = res.data.file_url;
                }
            });
        },

        /* Upload HospitaL Gallary Image 4 API */
        async hospital_gallery_photo_4_upload(filename, upload_image) {
            let data = {
                filename: filename,
                decode_base64: 1,
                filedata: upload_image,
            };
            await CommonApi.post_data(
                "sahaj.document.hospital_gallery_photo_4_upload",
                JSON.stringify(data)
            ).then((res) => {
                if (res && res.status_code == 200) {
                    this.new_hospital.photo_4 = res.data.file_url;
                }
            });
        },


        validateForm() {
            if (
                this.new_hospital.name_of_hospital === "" ||
                this.new_hospital.city === ""
            ) {
                this.disabled = true;
            } else {
                this.disabled = false;
            }
        },


        add_hospital() {
            if (!this.disabled) {
                this.$swal({
                    text: "Adding Hospital...",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    },
                });
                var data = new FormData();
                data.append("data", JSON.stringify(this.new_hospital));
                CommonApi.post_data("sahaj.api.add_hospital", data).then((res) => {
                    if (res && res.status_code === 200) {
                        this.$swal.fire({
                            icon: "success",
                            title: "Success",
                            text: res.message,
                            showConfirmButton: true,
                        }).then(() => {
                            this.$router.push("/doctor/profile-settings");
                        });
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            title: "Error",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }
                    (this.new_hospital.type_of_hospital = ""),
                        (this.new_hospital.name_of_hospital = ""),
                        (this.new_hospital.no_of_beds = ""),
                        (this.new_hospital.website = ""),
                        (this.new_hospital.state = ""),
                        (this.new_hospital.city = ""),
                        (this.new_hospital.suburb = ""),
                        (this.new_hospital.pincode = "");
                });
            }
        },

        /* Get States */
        async get_states() {
            await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
                this.states = res.message;
            });
        },

        /* Get States For Adding Hospital */
        async get_cities_for_addinghospital() {
            this.new_hospital.city = "";
            const params = new URLSearchParams();
            params.append("state", this.new_hospital.state);
            await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
                (res) => {
                    this.cities = res.message;
                }
            );
        },

        /* Get Healthcare Sub Categories */
        async get_healthcare_sub_categories() {
            await CommonApi.get_data(
                "sahaj.finalapi.get_healthcare_sub_categories"
            ).then((res) => {
                if (res.status_code == 200) {
                    this.hospital_types = res.data;
                }
            });
        },
    },
    mounted() {
        let user = localStorage.getItem("userInfo");
        if (!user) {
            this.$router.push({ name: 'login' })
        }
        this.get_states();
        this.get_healthcare_sub_categories();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/AddHospital.vue